import { IControlProvider } from '@ibiz-template/runtime';
/**
 * 树适配器
 *
 * @author lxm
 * @date 2022-10-25 18:10:57
 * @export
 * @class CalendarProvider
 * @implements {IControlProvider}
 */
export class CalendarProvider implements IControlProvider {
  component: string = 'IBizCalendarControl';
}
